import { DialogActions, DialogContent } from "@mui/material";
import {
  Button,
  Checkbox,
  DateTimePicker,
  Field,
  FieldsContainer,
  Form,
  PageHeader,
  TextField,
} from "common";
import I18n from "i18n-js";
import useIntegrationHistoryForm, {
  UseIntegrationHistoryFormProps,
} from "./useIntegrationHistoryForm";
export interface IntegrationHistoryFormProps
  extends UseIntegrationHistoryFormProps {}

export default function IntegrationHistoryForm({
  id,
  afterSave,
  onClose,
  listItem,
}: IntegrationHistoryFormProps) {
  const {
    item,
    options,
    errors,
    loading,
    isDirty,
    isCreate,
    getIsDirty,
    getRequiredFields,
    onChange,
    save,
    saving,
  } = useIntegrationHistoryForm({
    id,
    afterSave,
  });

  const title = I18n.t("IntegrationHistory.viewTitle");
  return (
    <>
      <PageHeader title={title} onClose={onClose} />
      <DialogContent>
        <Form
          loading={loading}
          item={item}
          options={options}
          errors={errors}
          onChange={onChange}
          translationCategory="IntegrationHistory.attributes"
          isDirty={getIsDirty}
          requiredFields={getRequiredFields()}
          disabled
        >
          <FieldsContainer>
            <Field fullWidth>
              <TextField id="id" />
            </Field>
            <Field fullWidth>
              <TextField id="integration_id" />
            </Field>
            <Field fullWidth>
              <TextField id="title" />
            </Field>
            <Field fullWidth>
              <TextField id="request" multiline />
            </Field>
            <Field fullWidth>
              <TextField id="response" multiline />
            </Field>
            <Field fullWidth>
              <DateTimePicker id="begin_at" />
            </Field>
            <Field fullWidth>
              <DateTimePicker id="end_at" />
            </Field>
            <Field fullWidth>
              <Checkbox id="success" />
            </Field>
          </FieldsContainer>
        </Form>
      </DialogContent>
      <DialogActions>
        <Button
          title={I18n.t("App.close")}
          onClick={() => onClose && onClose()}
        />
      </DialogActions>
    </>
  );
}
